import { BasicRequest } from "./basicRequest";

export class SampleFileRequest extends BasicRequest{

    public type! : string; //csv or fl
    public fieldDelimiter? : string;
    public hasHeader:boolean = false;
    public sampleRowAmount? : number; //how many rows to extract and return
  
    constructor(){
        super();
    }
}